<ng-container *ngIf="!editing">
    <div class="row" style="margin-top: 20px;">
      <div class="form-group col-4" >
        <label class="roboSubTitle" for="environment">{{ 'configuration.rubrica.search' | translate }} </label>
        <div class="input-group mb-3" >
          <input #src type="text" class="form-control" [placeholder]="'placeholder.search' | translate" aria-label="Cerca per nome"  aria-describedby="basic-addon1" (keyup.enter)="search(src.value)">
          <span class="input-group-text" id="basic-addon1" (click)="search(src.value)"><i class="bi bi-search" [ngbTooltip]="'tooltip.search' | translate"></i></span>
        </div>
      </div>
      
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class= "form-group col-auto">
          <button  type="button" class="btn btn-light" (click)='openEditor("new")' style="margin-top: 30px;"><i class="bi bi-plus"></i> {{ 'general.add' | translate }}</button> &nbsp;
          <button  type="button" class="btn btn-light" (click)="esportaRubrica()" style="margin-top: 30px;">{{ 'configuration.rubrica.export' | translate }}</button>  &nbsp;
          <input type="file" #pulsanteImporta accept=".einv" hidden (change)="importaRubrica($event)" />
          <button type="button" class="btn btn-light" (click)="pulsanteImporta.click()" style="margin-top: 30px;">{{ 'configuration.rubrica.import' | translate }}</button>
          <!--<button  type="button" class="btn btn-primary" ngf-drop="" (click)="importaRubrica($event)">{{ 'configuration.rubrica.import' | translate }}</button>-->
      </div>
    </div>

    <div [ngStyle]="{'justify-content': innerWidth! > 767 ? 'flex-end' : '100%'}" style="margin-bottom: 10px; margin-top:10px">
        <div class="row justify-content-between">
          <div class='col-auto' style="display: flex; flex-direction: row;">
            <label  class="form-check-label" style='margin-right: 5px;'>{{'general.show' | translate}}</label>
              <div class="dm7Select" >
                  <div class="select-side">
                    <img src="assets/icone_varie/arrow_down.svg">
                  </div>
                  <app-select class="selectDm7" 
                          [options]="pages" [key]="'key'" [value]="'key'"
                          [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="pages[1].key"
                          (change)="changePageSize($event.key)"></app-select>
              </div>
              <label  class="form-check-label">{{'paginator.rows' | translate}}</label>
          </div>
         
          <div class="col-4 ">
            <app-paginator [ngStyle]="{'width': innerWidth! > 767 ? 'auto' : '60%'}" *ngIf="addressesTable" 
                  [config]="addressesTable" (refresh)="getTable()" (next)="next()" (prev)="prev()" (setPage)="setPage($event)"></app-paginator>
          </div>  
        </div>
          
      </div>

    <ng-container *ngIf="addressesTable; else waiting">
        <div  *ngIf="addressesTable.data.length > 0; else noRes">
          <table class="table" >
            <thead>
              <tr >
                <th scope="col" (click)="sort('denominazione')" style="cursor: pointer;">Denominazione / Nome cognome<img [src]="'assets/icone_varie/' + sortUtils.getImgSort('denominazione')" style="width: 20px;"></th> 
                <th scope="col">Partita IVA</th>
              </tr>
            </thead> 
            <tbody>
              <tr *ngFor="let u of addressesTable.data" (click)="openEditor(u.id)" >
                <td *ngIf="u.denominazione.length > 0">{{u.denominazione}}</td>
                <td *ngIf="u.denominazione.length == 0">{{u.nome}} {{u.cognome}}</td>
                <td>{{u.partita_iva}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      
        <ng-template #noRes>
          <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #waiting>
        <app-loading></app-loading>
    </ng-template>

</ng-container>

<ng-container *ngIf="editing">
    <app-rubrica-editor [userId]='userId' [addressId]='editingId'></app-rubrica-editor>
</ng-container>
  
